import { useMessages } from "../context/MessagesContext";
import TreatmentCard from "../components/TreatmentCard";
import { getTratamientosData } from "../lib/tratamientosData";

export default function Tratamientos() {
  const labels = useMessages();
  const treatments = getTratamientosData(labels);

  return (
    <section id="tratamientos" className="scroll-mt-24">
      <div>
        <h2 className="section-title">
          {labels["treatments.title"]}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {treatments.map((t) => (
            <TreatmentCard
              key={t.slug}
              title={t.title}
              age={t.age}
              description={t.description}
              aditional={t.aditional}
              image={t.image}
              price={t.price}
              detailHref={`/tratamientos/${t.slug}`}
              detailLabel={labels["footer.see.more"] || "Ver mas"}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
